import { JSX } from "react";
import { BasicRecord } from "./basicRecord";
import { BasicTable } from "./BasicTable";
import { SummaryResultNetworkType, SummaryResultType } from "./enumerations";

interface NPIProps {
  providersEndpointFunc: (networkType: SummaryResultNetworkType, resultType: SummaryResultType, key: string) => string;
  records: BasicRecord[];
}

const NPI = (props: NPIProps): JSX.Element => <BasicTable {...props} records={props.records} tableName="Status" />;

export { NPI };
